module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/messenger-badge-nocolor-a696feb54b7e838b929de6df83cc1369.svg";